<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ov8qGa/images/cover-image.jpg?1702120377037" alt="This image is the cover for the book Ghost Shift"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghost Shift
      </h1>
      <p class="bookDescription body article font2">
        <p>Experience the secretive and dangerous new China in this explosive thriller from renowned journalist John Gapper</p><p><i>This wasn’t just a body in a field. The corpse’s shape was hers – same length, same curves. Then she knew, and everything else receded to nothingness. All she could see was a woman with the same nose, the same eyes, and the same face.</i></p><p><i>Her twin.</i></p><p>Agent Song Mei is a rising star in the Commission for Discipline Inspection. Her days are spent investigating political corruption… until she arrives on the scene of a gruesome murder and is confronted with a crime – and a victim – that is impossible to ignore.</p><p>Ignoring the warnings and threats of her superiors, Mei throws herself into a quest to uncover the mystery surrounding the corpse before her, which takes her into the dark heart of modern-day China. Soon it becomes clear that shadowy forces at home and abroad are implicated in a complex and far-reaching conspiracy.</p><p>From corrupt Communist officials, to tragedy-haunted CIA agents, through to suicidal factory workers, <i>The Ghost Shift</i> is a devastating portrait of a country coming to terms with the twenty-first century, and a brilliant and driven heroine coming to terms with her past.</p><p><b>John Gapper</b> is chief business commentator and associate editor of the <i>Financial Times</i> and a regular on BBC and CNN. He is also the author of <i>A Fatal Debt</i>. He lives in London.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Gapper
      </h2>
      
      <p class="authorDescription body article"><P>John Gapper is associate editor and chief business commentator of the Financial Times. He writes a weekly column, appearing on Thursdays on the Comment page, about business trends and strategy. He also contributes leaders and other articles.</P><P>He has worked for the FT since 1987, covering labour relations, banking and the media. In 1991-92, he was a Harkness fellow of the Commonwealth Fund of New York, and studied US education and training at the Wharton School of the University of Pennsylvania.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24857326